import { render } from "./tareaFinalizada.vue?vue&type=template&id=e8a06984"
import script from "./tareaFinalizada.vue?vue&type=script&lang=js"
export * from "./tareaFinalizada.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__